module.exports = __webpack_public_path__ + "media/playing_full_house_2.44acb1bf.mp3";